module.exports = __webpack_public_path__ + "img/password-gen-details2.cb6baa4c.png";